import { useEffect, useRef } from "react";
import "./Slidertext.css";
import Page from "../Book/Page.js";

const SliderText = ({ htmlContent }) => {
	const animationRef = useRef(null);

	function reset_animation() {
		if (animationRef.current) {
			animationRef.current.style.animation = "none";
			const off = animationRef.current.offsetHeight;
			animationRef.current.style.animation = "";
		}
	}

	useEffect(() => {
		reset_animation();
	}, [htmlContent]);

	return (
		<div className="slider-text">
			<Page id="book-page" className={"book-page"} ref={animationRef}>
				{htmlContent}
			</Page>
		</div>
	);
};

export default SliderText;